module.exports = __webpack_public_path__ + "img/left.ed3f913a.png";